export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";